import { getLocale } from "../i18n";
import { useRootLoaderData } from "./useRootLoaderData";

export function useLocale() {
  const rootData = useRootLoaderData();
  return getLocale(rootData.karrotLang);
}
